export const unique = (arr: any[]) =>
  arr.filter((value, index, self) => self.indexOf(value) === index);
